import { container } from './TreeMapOverlay.sty.js';
import { Flex } from '../../../../layouts/flex/Flex.js';
import { useGraphSize } from '../../../core/components/chart-layout/hooks/useGraphSize.js';
import { useTooltipData } from '../../../core/components/overlay-tooltip/_to-be-removed/utils.js';
import { useOverlay } from '../../../core/components/overlay-tooltip/contexts/OverlayContext.js';
import { useSeriesActions } from '../../../core/components/series-action/ChartSeriesActionContext.js';
import { isToolbarEnabled } from '../../../core/utils/is-toolbar-enabled.js';
import { useToolbarConfig } from '../../context/ToolbarContext.js';
import { TreeMapOverlayRefContext } from '../../contexts/TreeMapOverlayRefContext.js';
import { useOverlayHandlers } from '../../hooks/useOverlayHandlers.js';
import { TreeMapToolbar } from '../TreeMapToolbar/TreeMapToolbar.js';
import { TreeMapOverlayTooltip } from '../TreeMapTooltip/TreeMapOverlayTooltip.js';

export const TreeMapOverlay = () => {
  const overlay = useOverlay();
  const { width, height } = useGraphSize();
  const roundedWidth = Math.floor(width);
  const roundedHeight = Math.floor(height);

  const {
    handlePointerEnter,
    handlePointerMove,
    handlePointerLeave,
    handleMouseClick,
  } = useOverlayHandlers(overlay);

  const toolbarConfig = useToolbarConfig();
  const toolbarEnabled = isToolbarEnabled(toolbarConfig);
  const { chartSeriesActions } = useSeriesActions();
  const data = useTooltipData().data;

  const series = data?.series?.[0];
  const metadata = data?.metadata as { id: string; value: number } | undefined;

  return (
    <TreeMapOverlayRefContext.Provider value={overlay.overlayRef}>
      <Flex
        ref={overlay.overlayRef}
        style={{ width: roundedWidth, height: roundedHeight }}
        className={container}
        onClick={handleMouseClick}
        onPointerEnter={handlePointerEnter}
        onPointerMove={handlePointerMove}
        onPointerLeave={handlePointerLeave}
      >
        <TreeMapOverlayTooltip
          actionsForItem={
            chartSeriesActions && series && metadata
              ? () => () =>
                  chartSeriesActions({
                    id: metadata.id,
                    name: series.name,
                    value: metadata.value,
                  })
              : undefined
          }
        />
        {toolbarEnabled && <TreeMapToolbar />}
      </Flex>
    </TreeMapOverlayRefContext.Provider>
  );
};

TreeMapOverlay['displayName'] = 'TreeMapOverlay';
